export default "__VITE_ASSET__23403f76__"